export default __webpack_public_path__ + "static/shoe-cloud-5e08075ba76d11d4d7bb779da6935727.mp4";